<template>
  <div>
    <!-- {{form}} -->
    <el-container>
      <el-main style="padding: 15px 20px 15px;">
        <!-- {{formData}} -->
        <search-bar ref="search" @search="handleSearch" @exportCustom="exportCustom"></search-bar>
      </el-main>
    </el-container>
    <el-container>
      <el-main style="padding: 0 20px 10px 20px">
        <template v-if="!isReported">
          <el-table
            ref="table"
            border
            :data="tableData"
            :height="tableHeight+'px'"
            @sort-change="handleSortChange"
            v-if="tableHeight"
            v-loading="loading">
            <el-table-column label="图片" width="50px" fixed="left">
              <template slot-scope="scope">
                <el-link type="primary" :underline="false" v-if="scope.row.imgUrlList.length" @click="showDialog(scope.row, 0)">查看</el-link>
                <el-link :underline="false" disabled v-else>查看</el-link>
              </template>
            </el-table-column>
            <el-table-column label="产品编码" prop="productCode" width="150px" fixed="left" sortable="custom">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.productCode" placement="top" :open-delay="1000">
                  <span style="max-width:100%;display:inline-block;overflow: hidden; text-overflow: ellipsis;">{{scope.row.productCode}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="产品名称" prop="productName" min-width="280px" fixed="left" sortable="custom">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.productName" placement="top" :open-delay="1000">
                  <span style="max-width:100%;display:inline-block;overflow: hidden; text-overflow: ellipsis;">{{scope.row.productName}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="上市时间" prop="marketOn" width="120px" align="center" sortable="custom"></el-table-column>
            <el-table-column label="品类" prop="variety" width="120px" align="center"></el-table-column>
            <el-table-column label="材质" prop="material" width="120px" align="center"></el-table-column>
            <el-table-column label="风格" prop="style" width="120px" align="center"></el-table-column>
            <el-table-column :label="`${currentMonth}月预估`" prop="subMonthPlan" width="140px" align="right" sortable="custom">
              <template #header>
                <span>{{`${currentMonth}月预估`}}</span>
                <el-tooltip class="item" effect="dark" content="即在2个月前的月初导入的预估数据；" placement="top">
                  <span class="el-icon-warning-outline"></span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column :label="`${currentMonth}月预估调整`" prop="subMonthAdjust" width="140px" align="right" sortable="custom">
                <template #header>
                  <span>{{`${currentMonth}月预估调整`}}</span>
                  <el-tooltip class="item" effect="dark" content="即导入的调整预估数据，始终展示最新一版数据；最终以最新一版数据作为预估调整值来当月预销分数；" placement="top">
                    <span class="el-icon-warning-outline"></span>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <template v-if="isAllStoresReported && isAllPlan">
                    <el-link
                      type="primary"
                      :underline="false"
                      @click="showsubMonthAdjustRecord(scope.row)"
                      v-permission="`ec-pc-new$operationAnalysis$provide&require$preSalePlan$adjustDetail`"
                    >
                      {{scope.row.subMonthAdjust||0}}
                    </el-link>
                    <span v-no-permission="`ec-pc-new$operationAnalysis$provide&require$preSalePlan$adjustDetail`">{{scope.row.subMonthAdjust||0}}</span>
                  </template>
                  <template v-else>{{scope.row.subMonthAdjust}}</template>
              </template>
            </el-table-column>
            <el-table-column :label="`季度调整量`" prop="planAdjustMonth" width="140px" align="right" sortable="custom">
              <template #header>
                <span>季度调整量</span>
                <el-tooltip class="item" effect="dark" content="即每月15号之前导入的季度调整预估数据，始终展示最新一版数据；季度计算时，最终以季度内各月最新一版数据作为季度预估调整值汇总计算；" placement="top">
                  <span class="el-icon-warning-outline"></span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column :label="`${currentMonth}月大促预估`" prop="subMonthPromotion" width="140px" align="right" sortable="custom" v-if="columnsPromotion && columnsPromotion[0] && columnsPromotion[0].nodeName"></el-table-column>
            <el-table-column label="调整量" prop="subMonthDiffAmount" width="120px" align="right" sortable="custom">
              <template #header>
                <span>调整量</span>
                <el-tooltip class="item" effect="dark" content="预估调整 - 初次预估调整" placement="top">
                  <span class="el-icon-warning-outline"></span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column :label="`${nextCurrentMonth}月预估`" prop="subMonthNextPlan" width="140px" align="right" sortable="custom"></el-table-column>
            <el-table-column :label="`${nextCurrentMonth}月大促预估`" prop="subMonthNextPromotion" width="140px" align="right" sortable="custom" v-if="columnsPromotion && columnsPromotion[1] && columnsPromotion[1].nodeName"></el-table-column>
          </el-table>
        </template>

        <template v-else>
          <el-table
            ref="table"
            border
            :data="tableData"
            :height="tableHeight+'px'"
            @sort-change="handleSortChange"
            v-if="tableHeight"
            v-loading="loading">
            <el-table-column label="图片" width="50px" fixed="left">
              <template slot-scope="scope">
                <el-link type="primary" :underline="false" v-if="scope.row.imgUrlList.length" @click="showDialog(scope.row, 0)">查看</el-link>
                <el-link :underline="false" disabled v-else>查看</el-link>
              </template>
            </el-table-column>
            <el-table-column label="产品编码" prop="productCode" width="150px" fixed="left" sortable="custom">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.productCode" placement="top" :open-delay="1000">
                  <span style="max-width:100%;display:inline-block;overflow: hidden; text-overflow: ellipsis;">{{scope.row.productCode}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="产品名称" prop="productName" min-width="280px" fixed="left" sortable="custom">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.productName" placement="top" :open-delay="1000">
                  <span style="max-width:100%;display:inline-block;overflow: hidden; text-overflow: ellipsis;">{{scope.row.productName}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="上市时间" prop="marketOn" width="110PX" align="center" sortable="custom"></el-table-column>
            <el-table-column label="品类" prop="variety" width="110PX" align="center"></el-table-column>
            <el-table-column label="材质" prop="material" width="110PX" align="center"></el-table-column>
            <el-table-column label="风格" prop="style" width="110PX" align="center"></el-table-column>
            <el-table-column :label="`${currentMonth}月预估`" prop="subMonthPlan" width="110PX" align="right" sortable="custom">
              <template #header>
                <span>{{`${currentMonth}月预估`}}</span>
                <el-tooltip class="item" effect="dark" content="即在2个月前的月初导入的预估数据；" placement="top">
                  <span class="el-icon-warning-outline"></span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column :label="`${currentMonth}月预估调整`" prop="subMonthAdjust" width="140px" align="right" sortable="custom">
              <template #header>
                  <span>{{`${currentMonth}月预估调整`}}</span>
                  <el-tooltip class="item" effect="dark" content="即导入的调整预估数据，始终展示最新一版数据；最终以最新一版数据作为预估调整值来当月预销分数；" placement="top">
                    <span class="el-icon-warning-outline"></span>
                  </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column :label="`季度调整量`" prop="planAdjustMonth" width="140px" align="right" sortable="custom">
              <template #header>
                <span>季度调整量</span>
                <el-tooltip class="item" effect="dark" content="即每月15号之前导入的季度调整预估数据，始终展示最新一版数据；季度计算时，最终以季度内各月最新一版数据作为季度预估调整值汇总计算；" placement="top">
                  <span class="el-icon-warning-outline"></span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column :label="`${parseInt(currentMonth)}月初次预估调整`" prop="subMonthHistoryPlanAdjust" width="140px" align="right" sortable="custom">
              <template #header>
                <span>{{`${parseInt(currentMonth)}月初次预估调整`}}</span>
                <el-tooltip class="item" effect="dark" content="即首次导入的调整预估数据；" placement="top">
                  <span class="el-icon-warning-outline"></span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column :label="`${currentMonth}月大促预估`" prop="subMonthPromotion" width="140px" align="right" sortable="custom" v-if="columnsPromotion && columnsPromotion[0] && columnsPromotion[0].nodeName"></el-table-column>
            <!-- <el-table-column :label="`${currentMonth}月大促预估调整`" prop="subMonthPromotionAdjust" width="160px" align="right" sortable="custom" v-if="columnsPromotion && columnsPromotion[0].nodeName"></el-table-column> -->
            <el-table-column label="调整量" prop="subMonthDiffAmount" width="100px" align="right" sortable="custom">
              <template #header>
                <span>调整量</span>
                <el-tooltip class="item" effect="dark" content="预估调整 - 初次预估调整" placement="top">
                  <span class="el-icon-warning-outline"></span>
                </el-tooltip>
              </template>
            </el-table-column>
            <!-- 不是提报月份显示其他数据列 -->
            <template v-if="isReported">
              <el-table-column label="直播销量" prop="planLiveSalesResult" width="120PX" align="right" sortable="custom">
                <template #header>
                <span>直播销量</span>
                <el-tooltip class="item" effect="dark" content="根据导入的“达播订单”拆分后的直播销量；" placement="top">
                  <span class="el-icon-warning-outline"></span>
                </el-tooltip>
              </template>
              </el-table-column>
              <el-table-column label="实际销量" prop="salesResult" width="110PX" align="right" sortable="custom">
                <template slot-scope="scope">
                  <span v-if="isAllPlan">
                    <el-link type="primary" :underline="false" @click="showSalesResult(scope.row)">{{scope.row.salesResult}}</el-link>
                  </span>
                  <span v-else>{{scope.row.salesResult}}</span>
                </template>
              </el-table-column>
              <el-table-column label="截止3日销量（不含直播）" prop="endSalesResult" width="160PX" align="right" sortable="custom">
                <template #header>
                  <span>截止3日销量</span>
                  <el-tooltip class="item" effect="dark" content="（不含直播）" placement="top">
                    <span class="el-icon-warning-outline"></span>
                  </el-tooltip>
                </template>
              </el-table-column>
            <el-table-column label="当前应售" prop="finalPlanAmount" width="110PX" align="right" sortable="custom"></el-table-column>
            <el-table-column :label="`${beforeTwoMonth}月实销`" prop="ringActualSales" width="100PX" align="right" sortable="custom"></el-table-column>
            <el-table-column label="预/实销环比" prop="ringRate" width="120PX" align="right" sortable="custom">
              <template #header>
                <span>预/实销环比</span>
                <el-tooltip class="item" content="(M月最新预估值-(M-2)月实销)/(M-2)月实销" placement="top">
                  <span class="el-icon-warning-outline"></span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <span>{{scope.row.ringRate * 100 | formatFloat}}%</span>
              </template>
            </el-table-column>
            <el-table-column :label="`去年${currentMonthNumber}月实销`" prop="yoyActualSales" width="120PX" align="right" sortable="custom"></el-table-column>
            <el-table-column label="预/实销同比" prop="yoyRate" width="120PX" align="right" sortable="custom">
              <template #header>
                <span>预/实销同比</span>
                <el-tooltip class="item" content="(M月最新预估值-去年M月实销)/去年M月实销" placement="top">
                  <span class="el-icon-warning-outline"></span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <span>{{scope.row.yoyRate * 100 | formatFloat}}%</span>
              </template>
            </el-table-column>
            <el-table-column label="预估差额" prop="diffAmount" width="110PX" align="right" sortable="custom"></el-table-column>
              <el-table-column label="预估差异率" prop="diffRate" width="120PX" align="right" sortable="custom">
                <template slot-scope="scope">
                  <span style="color:#f56c6c" v-if="scope.row.diffRate > 0.2 || scope.row.diffRate < -0.2">{{scope.row.diffRate*100|formatFloat}}%</span>
                  <span v-else>{{scope.row.diffRate*100|formatFloat}}%</span>
                </template>
              </el-table-column>
              <el-table-column label="预估情况" prop="status" width="110PX" align="right" sortable="custom"></el-table-column>
              <el-table-column label="成交金额" prop="totalAmount" width="110PX" align="right" sortable="custom"></el-table-column>
            </template>
          </el-table>
        </template>

        <!-- pagination -->
        <div style="overflow: hidden;">
          <div style="float: left; margin-top: 15px; color: #555;">
            <span>{{dataUpdateObj.updateContent}}：</span>
            <span>{{dataUpdateObj.latestUpdateTime}}</span>
          </div>
          <el-pagination
            style="float: right; margin-top: 10px;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paginationOpt.pageNum"
            :page-sizes="paginationOpt.pageSizes"
            :page-size="paginationOpt.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationOpt.total">
          </el-pagination>
        </div>

        <!-- 图片&视频 -->
        <pic-video :data="rowData" :detailType="viewType" ref="picVideo"></pic-video>

        <!-- 实际销量 -->
        <sales-result v-model="salesResultVisible" :data="rowData" v-if="salesResultVisible"></sales-result>

        <!-- 编辑预估调整量 -->
        <sub-month-adjust v-model="subMonthAdjustVisible" :data="rowData" v-if="subMonthAdjustVisible"></sub-month-adjust>

        <!-- 预估调整弹窗列表 -->
        <sub-month-adjust-record v-model="subMonthAdjustRecordVisible" :data="rowData" v-if="subMonthAdjustRecordVisible"></sub-month-adjust-record>
      </el-main>
    </el-container>
  </div>
</template>

<script>
  import mixin from '@/views/preSalePlan/utils/mixin.js'
  import picVideoMixin from './pic&video.mixin'
  import salesResultMixin from './salesResult.mixin'
  import subMonthAdjustMixin from './subMonthAdjust.mixin'
  import subMonthAdjustRecordMixin from './subMonthAdjustRecord.mixin'

  import searchBar from './components/searchBar/searchBar'
  import saleSelect from '@/views/preSalePlan/common/saleSelect'

  export default {
  mixins: [mixin, picVideoMixin, salesResultMixin, subMonthAdjustMixin, subMonthAdjustRecordMixin],
  components: { searchBar, saleSelect },
  props: ['form', 'dataUpdateObj'],
  data() {
    return {
      formData: {},
      columnsPromotion: null,
      tableData: [],
      tableHeight: 0,
      loading: false,
      paginationOpt: {
        pageSizes: [30, 60, 90, 500],
        pageNum: 1,
        pageSize: 30,
        total: 0
      },
      // table 升序降序
      descOrAsc: '',
      fieldName: ''
    }
  },
  computed: {
    // 当前所在月份
    currentMonth() {
      return this.form.planTime.split('-')[1]
    },
    currentMonthNumber() {
      return Number(this.currentMonth)
    },
    // 当前所在月份的下一个月
    nextCurrentMonth() {
      let currentMonth = +this.currentMonth;
      currentMonth = currentMonth + 1;
      currentMonth = currentMonth > 12 ? currentMonth - 12 : currentMonth;
      return currentMonth;
    },
    beforeTwoMonth() {
      let date = new Date(`${this.form.planTime}-01`)
      date.setMonth(date.getMonth() - 2)
      return date.getMonth() + 1
    }
  },
  mounted() {
    this.getColumns_promotion();
    this.addListener_refresh();
    this.init();
  },
  methods: {
    async getColumns_promotion() {
      let params = {
        planTime: this.form.planTime
      }
      let res = await this.$q.preSalePlan.predictionNodeGet({params});
      if(res.success && res.data && res.data.length) {
        this.columnsPromotion = res.data;
      }else{
        this.columnsPromotion = [];
      }
    },
    handleSearch(data,type) {
      if(type == 1) {
        this.descOrAsc = '';
        this.fieldName = '';
        this.$nextTick(_=>{
          this.$refs.table.clearSort()
        })
      }
      this.formData = data;
      // 重置分页
      this.paginationOpt['pageNum'] = 1;
      this.init();
    },
    addListener_refresh() {
      this.$bus.$off('refresh');
      this.$bus.$on('refresh', _=>{
        this.tableHeight = 0;
        this.$nextTick(_=>{
          this.formData = { };
          if(this.$refs['search']) {
            this.$refs['search'].form = {};
          }
          // this.formData = { saleLocation: ''};
          // this.$refs['search'].form = { saleLocation: ''};
          // 重置分页
          this.paginationOpt['pageNum'] = 1;
          this.paginationOpt['pageSize'] = 30;
          this.getColumns_promotion();
          this.init();
        });
      });
    },
    getProductFilterData() {
      const filterData = {
        ...this.form,
        ...this.formData
      }
      return {
        descOrAsc: this.descOrAsc || '',
        fieldName: this.fieldName || '',
        marketTimeEnd: filterData.marketTimeEnd || '',
        marketTimeStart: filterData.marketTimeStart || '',
        planTime: filterData.planTime || '',
        productCode: filterData.productCode || '',
        productName: filterData.productName || '',
        queryAbnormalProductFlag: filterData.queryAbnormalProductFlag || '',
        saleLocation: filterData.saleLocation || '',
        status: filterData.status || '',
        storeId: filterData.storeId === undefined || filterData.storeId === null ? '' : filterData.storeId,
        useDay: filterData.useDay || ''
      }
    },
    async init() {
      this.tableHeight = document.documentElement.clientHeight - 325;
      this.loading = true;
      let data = {
        pageNum: this.paginationOpt.pageNum,
        pageSize: this.paginationOpt.pageSize,
        filterData: this.getProductFilterData()
      };
      let res;
      if(!this.isReported) {
        // 当月提报记录
        res = await this.$q.preSalePlan.productSubListPage({data})
      }else{
        // 历史记录
        res = await this.$q.preSalePlan.productResultListPage({data})
      }

      if(res && res.success && res.data) {
        this.tableData = res.data.records;
        this.paginationOpt.total = res.data.total;
      }else{
        this.tableData = [];
        this.paginationOpt.total = 0;
      }
      this.loading = false;
    },
    handleSizeChange(val) {
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    handleCurrentChange(val) {
      this.paginationOpt.pageNum = val;
      this.init();
    },
    handleSortChange({column, prop, order}) {
      this.paginationOpt.pageNum = 1
      console.log({column, prop, order});
      if(order === null) {
        this.descOrAsc = '';
        this.fieldName = '';
      }
      if(order === 'ascending') {
        this.descOrAsc = '';
        this.fieldName = prop;
      }
      if(order === 'descending'){
        this.descOrAsc = 'desc';
        this.fieldName = prop;
      }
      this.init();
    },
    // 导出 --新接口
    async exportCustom() {
      // let params = {
      //   taskDTO: {
      //     appCode: "ec-pc-new",
      //     // 数据过滤
      //     paramMap: {
      //       ...this.form,
      //       ...this.formData,
      //       descOrAsc: this.descOrAsc,
      //       fieldName: this.fieldName,
      //       pageNum: this.paginationOpt.pageNum,
      //       pageSize: 99999,
      //     },
      //     reportName: "productSubExport",
      //   },
      //   // 配置导出列
      //   columnDTOs: [
      //     // {
      //     //   columnName: '包件编码',
      //     //   parentColumnName: null,
      //     //   fieldName: 'packCode',
      //     //   fieldType: 'string',
      //     //   columnFormat: null
      //     // }
      //   ]
      // };
      // let labels = [
      //   '店铺名称',
      //   '产品编码',
      //   '产品名称',
      //   `${this.currentMonth}月预估`,
      //   `${this.currentMonth}月预估调整`,
      //   ...[this.columnsPromotion && this.columnsPromotion[0].nodeName ? `${this.currentMonth}月大促预估` : null],
      //   `${this.nextCurrentMonth}月预估`,
      //   ...[this.columnsPromotion && this.columnsPromotion[0].nodeName ? `${this.nextCurrentMonth}月大促预估` : null]
      // ]
      // let props = [
      //   'storeName',
      //   'productCode',
      //   'productName',
      //   'subMonthPlan',
      //   'subMonthAdjust',
      //   ...[this.columnsPromotion && this.columnsPromotion[0].nodeName ? 'subMonthPromotion' : null],
      //   'subMonthNextPlan',
      //   ...[this.columnsPromotion && this.columnsPromotion[0].nodeName ? 'subMonthNextPromotion' : null]
      // ];
      // props.forEach((prop, index) => {
      //   if(prop) {
      //     params.columnDTOs.push({
      //       columnName: labels[index],
      //       parentColumnName: null,
      //       fieldName: prop,
      //       fieldType: 'string',
      //       columnFormat: null
      //     })
      //   }
      // })
      // // /qu-platform-excel-api/excel/customColumn/export/task
      // this.$q.common.customExportExcel({data: params}).then((res) => {
      //   console.log(res)
      //   this.$message({
      //     type: "success",
      //     message: "导出成功,请在导出列表中查看",
      //   });
      // });

      try {
        const res = await this.$q.preSalePlan.listPagExcel({
          data: {
            exportTag: true,
            pageNum: 1,
            pageSize: 99999,
            filterData: this.getProductFilterData()
          },
          options: {
            responseType: 'blob'
          }
        })
        this.blobDownload(res, `产品预估数据.xls`)
      } catch (error) {
        this.$message.error('导出失败')
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  // >>> .el-table .el-table__body-wrapper
  //   &::-webkit-scrollbar
  //     height 0px !important
  // >>> .el-table .el-table__fixed
  //   &::-webkit-scrollbar
  //     height 0px !important
</style>
